import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'floor',
    standalone: true
})
export class FloorPipe implements PipeTransform {

  transform(value: number|string): number|string {
    if (typeof value === 'string') {
      const asNumber = parseInt(value, 10);
      if (isNaN(asNumber)) {
        return value;
      }
      return asNumber;
    }
    return Math.floor(value);
  }
}
